module.exports = __webpack_public_path__ + "static/img/orange.e9d4fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bodyparts/4/orange.png
// module id = JZLI
// module chunks = 94